import { createRoutine } from 'redux-saga-routines';

export enum PlanAnalyticAction {
  'PLAN_ANALYTIC/GET' = 'PLAN_ANALYTIC/GET'
}

export const planAnalyticGetRoutine = createRoutine(PlanAnalyticAction['PLAN_ANALYTIC/GET']);

export const plannerPlanAnalyticRoutinesWithNotifier = [planAnalyticGetRoutine];
